import React from 'react';
import ShowQRButton from './ShowQRButton';
import PropTypes from 'prop-types';
import AddDeviceButton from './AddDeviceButton';
import ScanDeviceButton from './ScanDeviceButton';

const VirtualStationActions = ({
    record,
    resource,
    permissions,
}) => {
    return (
        <>
            <ShowQRButton
                record={record}
                resource={resource}
                permissions={permissions}
            />
            <ScanDeviceButton
                record={record}
                resource={resource}
                permissions={permissions}
            />
            <AddDeviceButton
                record={record}
                resource={resource}
                permissions={permissions}
            />
        </>
    );
};

VirtualStationActions.propTypes = {
    permissions: PropTypes.string,
    record: PropTypes.object,
    resource: PropTypes.string,
}
export default VirtualStationActions
